import { render } from "./content.vue?vue&type=template&id=4add046a&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"

import "./content.vue?vue&type=style&index=0&id=4add046a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4add046a"]])

export default __exports__